import { ReplaySubject } from '@mbrtargeting/metatag-utils';

export interface SystemBusEvent {
    type: string;
    slotId: undefined;
}

export interface SlotBusEvent {
    type: string;
    slotId: string;
    slotName: string;
}

export const eventBus$ = new ReplaySubject<SystemBusEvent | SlotBusEvent>(1e6);
